import {ILearningPathsEditStoreState} from './ILearningPathsEditStoreState';
import {learningPathEditInitialState} from './learningPathsEdit.initialState';

export const learningPathEditReducer = {
  clearLearningPath: (state: ILearningPathsEditStoreState) => {
    state.learningPath = {...learningPathEditInitialState.learningPath};
  },
};
